





import { Vue, Component, Watch, Prop } from "vue-property-decorator";

@Component({
  name: "uc-header-title-default"
})
export default class UcHeaderTitleDefaultComponent extends Vue {}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./scripts/views/layouts/header/uc-header-title-default.vue